import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ErrorService } from 'src/app/services/error.service';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrl: './error-dialog.component.scss',
    standalone: false
})
export class ErrorDialogComponent implements OnDestroy{
  errorMessage: string | null = null;
  showDialog: boolean = false;
  private errorSubscription: Subscription


  constructor(private errorService: ErrorService) {
    this.errorSubscription = this.errorService.getErrorMessage().subscribe(message => {
      this.errorMessage = message;
      this.showDialog = !!message;
    })
    
  }

  ngOnDestroy(): void {
    if (this.errorSubscription) {
      this.errorSubscription.unsubscribe();
    }
  }
}
